import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ConfirmationMessageType } from './confirmation-message-type.interface';
import { ConfirmationMessageTypeService } from './confirmation-message-type.service';

const service = new ConfirmationMessageTypeService();

export interface ConfirmationMessageTypeState {
   confirmationMessageTypes: Array<ConfirmationMessageType>;
}

const ConfirmationMessageTypeStore: Module<ConfirmationMessageTypeState, StoreState> = {
   namespaced: true,
   state: {
      confirmationMessageTypes: [],
   },
   getters: {
      confirmationMessageTypes: (state) => state.confirmationMessageTypes,
   },
   mutations: {
      SET_CONFIRMATION_MESSAGE_TYPES(state, confirmationMessageTypes: Array<ConfirmationMessageType>) {
         state.confirmationMessageTypes = confirmationMessageTypes;
      },
   },
   actions: {
      async getConfirmationMessageTypes(context, query?: LocationQuery) {
         const response = await service.getConfirmationMessageTypes(query);
         context.commit('SET_CONFIRMATION_MESSAGE_TYPES', response.data);
         return response.data;
      },
   },
};

export default ConfirmationMessageTypeStore;
